import ModelTransfer from "@models/v2/transfer/ModelTransfer";
import {computed, ComputedRef, effectScope, ref, Ref} from "vue";
import RepositoryTransfers from "@/repositories/v2/repository-transfers/RepositoryTransfers";

export default class ServiceTransfers {
	private _scope = effectScope(true)
	private static _instance: ServiceTransfers | null = null;
	private readonly _repositoryTransfers: RepositoryTransfers;
	private readonly _transfers: Ref<ModelTransfer[]>
	private readonly _selectedTransferId: Ref<number | null>;

	public readonly selectedTransfer: ComputedRef<ModelTransfer | null>;
	public readonly selectedTransferAccountName: ComputedRef<string | null>;

	constructor() {
		this._repositoryTransfers = new RepositoryTransfers();
		this._transfers = ref([]);
		this._selectedTransferId = ref(null);

		this.selectedTransfer = this._scope.run(() => computed<ModelTransfer | null>(() => {
			if (this._selectedTransferId.value) {
				return this._transfers.value.find((t) => this._selectedTransferId.value === t.service.id) ?? null;
			} else {
				return null;
			}
		})) as ComputedRef;

		this.selectedTransferAccountName = this._scope.run(() => computed(() => {
			if (this.selectedTransfer.value) {
				if (this.selectedTransfer.value.contact.email) return this.selectedTransfer.value.contact.email;
				else if (this.selectedTransfer.value.contact.phone) return this.selectedTransfer.value.contact.phone;
				else if (this.selectedTransfer.value.login) return this.selectedTransfer.value.login;
				else return null;
			} else {
				return null;
			}
		})) as ComputedRef;
	}

	public static of() {
		if (ServiceTransfers._instance === null) {
			ServiceTransfers._instance = new ServiceTransfers();
		}

		return ServiceTransfers._instance;
	}

	public async fetchTransfers() {
		this._transfers.value = await this._repositoryTransfers.fetchTransferList();
	}

	public async createTransfer(amount: number, transfer: ModelTransfer) {
		return await this._repositoryTransfers.createTransfer(amount, transfer.clientId);
	}

	public get transfers(): Ref<ModelTransfer[]> {
		return this._transfers;
	}

	public set transfers(transfers: ModelTransfer[]) {
		this._transfers.value = transfers;
	}

	public get selectedTransferId(): Ref<number | null> {
		return this._selectedTransferId;
	}

	public set selectedTransferId(value: number | null) {
		this._selectedTransferId.value = value;
	}
}
